import React, { Component } from 'react';
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";

export default class SimulateBotStoreConfig extends Component {
    constructor() {
        super();
        this.state = {
            data: [],
            successResp: true,
            editedId: '-1',
            appInstanceParamData: [],
            appId: null
        }

        this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
        this.editImageSrc = "./assets/images/edit2.png";
    }
    componentDidMount() {
        var thisController = this;
        setTimeout(() => {
            thisController.fetchStoreDataApi();
            thisController.fetchAppInstanceParamValuesApi();
        }, 300);
        document.addEventListener("projectChanged", function (event) {
            thisController.projectId = event.projectId;
            thisController.fetchStoreDataApi(event.projectId);
            thisController.fetchAppInstanceParamValuesApi(event.projectId);
        });
    }

    fetchStoreDataApi = (projectId) => {
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
                projectId = localStorage.getItem('currentProjectId');
            }
        }
        var storeComponent = this;
        storeComponent.state.keywordList = [];
        $.ajax({
            url: "/api/app",
            async: false,
            method: 'GET',
            data: {
                templateProjectId: projectId,
            },
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token"),
            },
            success: function (res) {
                if (res.success === true) {
                    storeComponent.state.fields = res.result.app;
                    if (Object.keys(res.result.app).length > 0) {
                        storeComponent.state.appId = res.result.app.id;
                    } else {
                        storeComponent.notifyMissingAppDetails("Please fill basic app details");
                        setTimeout(() => {
                            window.location.href = window.origin + "/platform/projectmgmt/bot-store";
                        }, 1000)
                    }
                } else {
                    storeComponent.notifyMissingAppDetails("Please fill basic app details");
                    setTimeout(() => {
                        window.location.href = window.origin + "/platform/projectmgmt/bot-store";
                    }, 1000)
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/platform/";
                }
            }
        });
    }

    fetchAppInstanceParamValuesApi = (projectId) => {
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
                projectId = localStorage.getItem('currentProjectId');
            }
        }
        var storeComponent = this;
        $.ajax({
            url: "/api/app-instance-param-values",
            async: false,
            method: 'GET',
            data: {
                templateProjectId: projectId
            },
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token"),
            },
            success: function (res) {
                storeComponent.state.successResp = true;
                if (res.success === true) {
                    if (res.result.length > 0) {
                        storeComponent.state.isDataPresent = true;
                        for (var i = 0; i < res.result.length; i++) {
                            var possibleValues = [];
                            if (res.result[i].possibleValues != null && res.result[i].possibleValues.includes(",")) {
                                possibleValues = res.result[i].possibleValues.split(",");
                                res.result[i].possibleValues = possibleValues;
                            } else {
                                res.result[i].possibleValues = possibleValues;
                            }
                        }
                    } else {
                        storeComponent.state.isDataPresent = false;
                    }
                    storeComponent.state.data = res.result;
                }
                storeComponent.state.editedId = "-1";
                storeComponent.setState(storeComponent.state);
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/platform/";
                }
            }
        });
    }

    validateParamValue = (paramValue) => {
        if (paramValue == null || paramValue == "") {
            this.notifyInvalidFields("Please enter the value");
            return false;
        } else {
            return true;
        }
    }

    notifyInvalidFields = (message) => {
        toast.dismiss();
        toast(<b> <img src="./assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" /> &nbsp;&nbsp; {message}</b >, {
            position: "top-center"
        });
    }

    notifyMissingAppDetails = (message) => {
        toast.dismiss();
        toast(<b> <img src="./assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" /> &nbsp;&nbsp; {message}</b >, {
            position: "top-center"
        });
    }

    saveDetails = (item, e) => {
        e.preventDefault();
        let storeComponent = this;
        var paramValue = item.possibleValues == null || item.possibleValues.length == 0 ?
            document.getElementById("paramName" + item.appParamId).value :
            document.getElementById("paramNameDropdown" + item.appParamId).value;

        if (storeComponent.validateParamValue(paramValue)) {
            let data = {
                appId: storeComponent.state.appId,
                projectId: localStorage.getItem('currentProjectId'),
                templateProjectId: localStorage.getItem('currentProjectId'),
                paramName: item.paramName,
                paramValue: paramValue,
                appParamId: item.appParamId
            }
            $.ajax({
                url: "/api/app-instance-param-values",
                type: 'POST',
                async: false,
                headers: {
                    "Authorization": "Bearer" + localStorage.getItem("access_token"),
                    "Content-Type": "application/json"
                },
                data: JSON.stringify(data),
                success: function (res) {
                    if (res.success === true) {
                        storeComponent.notifyAdded();
                        storeComponent.fetchAppInstanceParamValuesApi();
                        storeComponent.state.successResp = true;
                    } else {
                        storeComponent.state.successResp = false;
                        storeComponent.notifyFailToLoad(res.result);
                    }
                    storeComponent.setState(storeComponent.state);
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/";
                    }
                }
            });
        }
    }

    notifyAdded() {
        toast.dismiss();
        toast(<b><img src="./assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Added Successfully</b>, {
            position: "top-center",
        });
    }

    updateSimulateBotStoreApi = (item, e) => {
        e.preventDefault();
        let storeComponent = this;
        var paramValue = item.possibleValues == null || item.possibleValues.length == 0 ?
            document.getElementById("paramName" + item.appParamId).value :
            document.getElementById("paramNameDropdown" + item.appParamId).value;

        if (storeComponent.validateParamValue(paramValue)) {
            let data = {
                id: item.id,
                appId: storeComponent.state.appId,
                projectId: localStorage.getItem('currentProjectId'),
                templateProjectId: localStorage.getItem('currentProjectId'),
                paramName: item.paramName,
                paramValue: paramValue,
                appParamId: item.appParamId
            }
            $.ajax({
                url: "/api/app-instance-param-values",
                type: 'PATCH',
                async: false,
                headers: {
                    "Authorization": "Bearer" + localStorage.getItem("access_token"),
                    "Content-Type": "application/json"
                },
                data: JSON.stringify(data),
                success: function (res) {
                    storeComponent.state.successResp = true;
                    if (res.success === true) {
                        storeComponent.notifySuccessToast("Bot Settings updated Successfully");
                        storeComponent.fetchAppInstanceParamValuesApi();
                    } else {
                        storeComponent.notifyFailToLoad(res.result);
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/";
                    }
                }
            });
        }
    }

    notifySuccessToast(response) {
        toast.dismiss();
        toast(<b>
            <img src="./assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />
            &nbsp;&nbsp;{response}</b>, {
            position: "top-center"
        });
    }

    handleChange = (item, e) => {
        item.paramValue = e.target.value;
        this.setState(this.state);
    }

    refreshData = () => {
        this.fetchAppInstanceParamValuesApi();
    }

    makeCelleditable = (item, e) => {
        e.preventDefault();
        this.state.editedId = item.appParamId;
        this.setState(this.state);
    }

    notifyFailToLoad(response) {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>{response}</b>, {
            position: "top-center",
            color: "red"
        });
    }

    render() {
        return (
            <div>
                {/* <link rel="stylesheet" href="assets/css/style.css" /> */}
                <link rel="stylesheet" href="assets/css/toggleButton.css" />
                {/* for toaster */}
                <link rel="stylesheet" href="assets/css/ReactToastify.css" />
                {/* for reactTable */}
                <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />
                <ToastContainer className="Toast-at-center" />
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-6">
                            <h6 className="nav-item" style={{
                                color: '#282a65',
                                marginTop: '24px', marginLeft: '-2px'
                            }}>BotStore Demo Configuration</h6>
                        </div>
                        {/* Add button and refresh button*/}
                        <div className="col-sm-6" Align='right'>
                            <button onClick={this.refreshData} className="btn action-button" title="Refresh">
                                <img src="./assets/images/refresh_white_24dp.png"></img>
                            </button>
                        </div>

                    </div>
                </div>
                <div className="content">
                    <div className="container-fluid">
                        <div className="row" >
                            <div className="col-lg-12 ">
                                <div className="card modal-body" style={{ border: '1px solid #ced4da', borderRadius: '7px', display: this.state.isDataPresent ? 'block' : 'none' }}>
                                    <form style={{ height: 'auto' }} >
                                        {this.state.data.map(item => (
                                            <div style={{
                                                color: '#282a65',
                                                fontSize: '1.1rem',
                                                margin: '20px 40px 20px 40px'
                                            }}>

                                                {/* Edit Row*/}
                                                <div style={{ marginLeft: '85%' }}>
                                                    <p>
                                                        <button style={{ backgroundColor: "#ffffff", border: "none" }}>
                                                            <img className="img-responsive"
                                                                title={(item.id == null) || (item.appParamId == this.state.editedId) ? 'Save' : 'Edit'}
                                                                style={{

                                                                    marginTop: '8px', backgroundColor: '#282a65', borderRadius: '5px',
                                                                    padding: '1px', cursor: 'pointer'
                                                                }}
                                                                src={(item.projectId == null) ?
                                                                    this.saveImageSrc : ((item.appParamId != this.state.editedId) ?
                                                                        this.editImageSrc : this.saveImageSrc)}
                                                                onClick={(e) => {
                                                                    (item.projectId == null) ?
                                                                        this.saveDetails(item, e) :
                                                                        (item.appParamId == this.state.editedId) ?
                                                                            this.updateSimulateBotStoreApi(item, e) :
                                                                            this.makeCelleditable(item, e);
                                                                }}
                                                            />
                                                        </button>
                                                    </p>
                                                </div>

                                                <div className="row" style={{ marginTop: '20px' }}>
                                                    <div className="col-sm-2" align="left" style={{ marginTop: '10px' }}>{item.paramName}</div>
                                                    <input className="col-sm-4"
                                                        type="text"
                                                        name="name" id={"paramName" + item.appParamId}
                                                        onChange={(e) => this.handleChange(item, e)} value={item.paramValue}
                                                        disabled={item.projectId == null ? false : (item.appParamId != this.state.editedId)}
                                                        style={{
                                                            padding: '0.375rem 0.75rem', textAlign: 'left',
                                                            display: item.possibleValues == null || item.possibleValues == "" ? 'block' : 'none',
                                                            borderBottom: (item.projectId == null || item.appParamId == this.state.editedId) ? '1px solid #D2D4DC' : 'none',

                                                        }} />

                                                    <select className="input-group mb-3 form-control select2 "
                                                        id={"paramNameDropdown" + item.appParamId}
                                                        value={item.paramValue}
                                                        onChange={(e) => this.handleChange(item, e)}
                                                        disabled={item.projectId == null ? false : (item.appParamId != this.state.editedId)}
                                                        style={{
                                                            height: '30px', borderRadius: '4px',
                                                            backgroundColor: '#F9F9FB', padding: '0.375rem 0.75rem',
                                                            display: item.possibleValues == null || item.possibleValues == "" ? 'none' : 'block',
                                                        }} >
                                                        {item.possibleValues.map((i) => (
                                                            <option value={i}> {i}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="row">
                                                    <div className="col-sm-2" style={{ marginTop: '10px' }}></div>
                                                    <div className="col-sm-4" style={{ marginTop: '10px', padding: '0.375rem 0.75rem' }}>
                                                        ({item.paramDescription})
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                        }
                                    </form>
                                </div>
                                <div align="center" style={{ display: this.state.isDataPresent ? 'none' : 'block' }}>
                                    <div className="modal-body" style={{ paddingLeft: '0px', paddingRight: '0px' }}>
                                        <form className="form-control" style={{ height: 'auto' }} >
                                            <div style={{ padding: '70px' }}>
                                                <img src="./assets/images/warn.svg" height="50px" width="50px" />
                                                <br /><br />
                                                <label style={{ fontSize: '20px' }}>
                                                    No Customization required for this bot
                                                </label><br />
                                                <label style={{ fontSize: '15px' }}>
                                                    If you have any query, please write to the developer at {"shilpa.m@dheeyantra.com"}
                                                </label>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/projectmgmt/testAndDeploy/appStore/SimulateBotStoreConfig.js